import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2
} from '@angular/core';


export class AngularBillboardComponent implements OnInit {
    
    private el: HTMLElement;
     private chart: any;
    
    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
        this.el = elementRef.nativeElement;
    }
    
    ngOnInit() {
        this.renderer.appendChild(this.el, this.chart.element);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'angular-billboard',
    template: '<!-- angular-billboard-chart -->'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'chart': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
